import * as React from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Typography } from "@mui/material";
import { IExpectation } from "./Interfaces";
import { COLORS } from "src/constants/watchRTCExpectation";

interface IProps {
  types: string[];
  filteredData: IExpectation[];
  setFilteredData: (filteredData: IExpectation[]) => void;
  checked: boolean[];
  setChecked: (checked: any) => void;
  expanded: boolean;
}
export default function TableFilter({ types, filteredData, setFilteredData, checked, setChecked, expanded }: IProps) {
  const handleChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = [...checked];
    newChecked[index] = event.target.checked;
    setChecked(newChecked);
  };

  const areAllChecked = () => {
    return checked.every(Boolean);
  };

  React.useEffect(() => {
    const numChecked = checked.reduce((total, curr) => (curr ? total + 1 : total), 0);
    const filtered = filteredData.filter((item) => {
      if (numChecked === 0) {
        return true;
      } else if (numChecked === types.length) {
        return true;
      } else {
        return checked[types.indexOf(item.type)];
      }
    });
    setFilteredData(filtered);
  }, [checked, filteredData]);

  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      {types.map((type, index) => (
        <FormControlLabel
          key={type}
          label={
            <Typography
              fontSize={"12px"}
              fontWeight={500}
              lineHeight={"14px"}
              letterSpacing={"0.65px"}
              color={"#121C2D"}
              textTransform={"uppercase"}
            >
              {type}
            </Typography>
          }
          control={
            <Checkbox
              checked={checked[index]}
              onChange={handleChange(index)}
              sx={{
                padding: "4px 12px 4px 4px",
                "&.Mui-checked": {
                  color: COLORS[type.toLowerCase()],
                },
              }}
              size="small"
            />
          }
        />
      ))}
    </Box>
  );

  return (
    <Box
      sx={{
        display: expanded ? "flex" : "none",
        flexDirection: "column",
        marginLeft: "8px",
        marginTop: "20px",
      }}
    >
      <FormControlLabel
        label={
          <Typography
            fontSize={"12px"}
            fontWeight={500}
            lineHeight={"14px"}
            letterSpacing={"0.65px"}
            color={"#121C2D"}
            textTransform={"uppercase"}
          >
            All
          </Typography>
        }
        control={
          <Checkbox
            checked={areAllChecked()}
            indeterminate={!areAllChecked() && checked.some(Boolean)}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const newChecked = event.target.checked;
              setChecked([newChecked, newChecked]);
            }}
            size="small"
            sx={{ padding: "4px", marginLeft: 0 }}
          />
        }
      />
      {children}
    </Box>
  );
}
